import type { MimeType } from 'features/files/types';
import type { BaseConfig } from '../types';

// Common MIME types for image handling
const COMMON_IMAGE_MIME_TYPES: MimeType[] = ['bmp', 'jpeg', 'png', 'webp'];

const baseConfig: BaseConfig = {
  textExtract: {
    maxWordsPerDocument: 75_000,
    maxWordsPerGeneration: 75_000,
    maxCharactersPerDocument: 450_000,
    pdf: {
      languagesWithoutALotOfSpaces: ['ar', 'de', 'en-gb', 'en-us', 'es', 'fr', 'id', 'it'],
      otherToSpaceRatioErrorThreshold: 3,
      textDidNotParseErrorCharThreshold: 40,
    },
    image: {
      textDidNotParseErrorCharThreshold: 20,
      validMimeTypes: COMMON_IMAGE_MIME_TYPES,
    },
    word: {
      findBoundaryRegex: /boundary="([^"]*)"/,
      textContentTypeString: 'Content-Type: text/html;',
      stripUnneededContentRegex: /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g,
    },
  },
  imageGenerator: {
    validMimeTypes: COMMON_IMAGE_MIME_TYPES,
  },
  images: {
    validMimeTypes: COMMON_IMAGE_MIME_TYPES,
  },
  passwords: {
    isValidRegex: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}/,
  },
};

export default baseConfig;
